import { useCurrentUser } from '@invitae/cms-blocks';
import useLocationPathname from './useLocationPathname.esm.js';

var defaultNavigationCTAPath = {
    patient: '/testing-options',
    physician: '/start-order/#/dashboard',
};
var useDefaultNavigationCTA = function () {
    var _a;
    var currentUser = useCurrentUser();
    var pathname = useLocationPathname();
    // Signed in patients should go to testing options page
    // Signed in providers should go to test catalog hub
    if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isUserAuthenticated) {
        return {
            hideOrderNowLink: false,
            navigationCta: 'Order now',
            navigationCtaPath: defaultNavigationCTAPath[(_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) !== null && _a !== void 0 ? _a : 'patient'],
        };
    }
    // All providers pages should go to test catalog hub
    if (pathname.includes('/providers')) {
        return {
            hideOrderNowLink: false,
            navigationCta: 'Order now',
            navigationCtaPath: '/providers/test-catalog',
        };
    }
    return {
        hideOrderNowLink: false,
        navigationCta: 'Order now',
        navigationCtaPath: '/testing-options',
    };
};

export { useDefaultNavigationCTA as default };
//# sourceMappingURL=useDefaultNavigationCTA.esm.js.map
